import React from 'react';
import { useMackAcquisitionView } from '../../lib/mackAcquisitionView';
import { AcquisitionEvidence } from './AcquisitionEvidence';
import { InputsLivePanel } from './InputsLivePanel';

export function InputsTab({ authToken, onCalendarEvent }: { authToken?: string | null; onCalendarEvent?: (eventId: string) => void } = {}) {
  const acquisition = useMackAcquisitionView('inputs.macro_variables', authToken);
  const sheetCode = 'USD';
  return <div style={{ display: 'flex', flexDirection: 'column', gap: 17, minWidth: 0 }}>
    <details style={{ color: '#a99a8c', fontSize: 12 }}>
      <summary>Existing raw acquisition evidence — unverified for Inputs</summary>
      <AcquisitionEvidence {...acquisition} sheet={sheetCode} />
    </details>
    <InputsLivePanel authToken={authToken} onCalendarEvent={onCalendarEvent} />
  </div>;
}
